<template>
  <div class="col-xs-12 col-sm-12 offset-md-1 col-md-10">
    <el-divider class="divider-green"></el-divider>

    <div class="row d-flex justify-content-between align-items-center">
      <div class="block">
        <h2>Audit Log</h2>
        <p v-if="user" class="text-muted mb-1">User: {{ formatFullName(user) }}</p>
        <p v-if="groupedAuditLog.length > 0">
          Displaying {{ this.auditLog.length }} logs of {{ this.totalAuditLogCount }}
        </p>
      </div>
      <div>
      <div class="row d-flex align-items-center">
       
        <div style="padding-left:20px">
          <base-button @click="exportPDF()" class="btn-dark float-sm-none float-md-left">Export PDF</base-button>
        </div>
        <div style="width: 300px; padding-left:20px">
          <el-input :disabled="!this.isUserIdAvailable" @input="searchInput()" v-model="search"
            placeholder="Type to search" />
        </div>
         <div>
          <base-button @click="$router.back()"  class="btn btn-secondary"><span> Back </span></base-button>
        </div>
      </div>
    </div>
    </div>
    
    <br />

    <div class="block">

      <br />
      <el-timeline v-if="groupedAuditLog && groupedAuditLog.length && this.isUserIdAvailable">
        <el-timeline-item v-for="(group, index) in groupedAuditLog" :timestamp="group.logDate | formatDateTime" :key="index"
          placement="top">
          <el-card shadow="never">
            <div class="row">
              <div class="col-md-12">
                <el-table :data="group.items" role="table" aria-label="Audit Logs Table">
                  <el-table-column prop="updateBy" label="Update By" scope="col">
                  </el-table-column>
                  <el-table-column prop="action" label="Action" scope="col">
                  </el-table-column>
                  <el-table-column label="Field Name" scope="col">
                    <template slot-scope="scope">
                      <span v-if="scope.row.fieldName && scope.row.fieldName.includes('[') && scope.row.fieldName.includes(']')">
                        {{ getShortFieldName(scope.row.fieldName) }} - {{ getFileType(scope.row.fieldName) }}
                        <el-tooltip effect="light" placement="top">
                          <div slot="content">
                            <strong>File Name:</strong> {{ getFileName(scope.row.fieldName) }}
                          </div>
                          <i class="el-icon-info" style="margin-left: 4px; cursor: pointer; color: #409EFF;"></i>
                        </el-tooltip>
                      </span>
                      <span v-else>{{ scope.row.fieldName }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="Previous Value" scope="col">
                    <template slot-scope="scope">
                      <AuditSignature v-if="isSignatureField(scope.row.fieldName) && isSignatureValue(scope.row.oldValue)"
                        :signature-data="scope.row.oldValue" />
                      <p v-else>{{ formatValue(scope.row.oldValue, scope.row.valueDataType, scope.row.fieldName) }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="Current Value">
                    <template slot-scope="scope">
                      <AuditSignature v-if="isSignatureField(scope.row.fieldName) && isSignatureValue(scope.row.newValue)"
                        :signature-data="scope.row.newValue" />
                      <p v-else>{{ formatValue(scope.row.newValue, scope.row.valueDataType, scope.row.fieldName) }}</p>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-card>
        </el-timeline-item>
        
        <!-- Show More Button -->
        <div class="text-center pt-4">
          <base-button v-if="auditLog.length < totalAuditLogCount" @click="loadMoreAuditLogs()" type="primary">Show More</base-button>
        </div>
      </el-timeline>
      <el-card v-else>
        <div class="text-center pt-4">
          <h2>
            {{ !auditLog.length ? "No Results found" : auditLogLoadingText }}
          </h2>
        </div>
      </el-card>

    </div>
  </div>
</template>

<script>
import {
  Table,
  TableColumn,
  Divider,
  Tag,
  Card,
  Timeline,
  TimelineItem,
} from "element-ui";

import { mapActions, mapGetters } from "vuex";
import Util from "@/util/util";
import axios from '@/axios';
import dayjs from "dayjs";
import AuditSignature from "@/components/App/signatures/AuditSignature";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Divider.name]: Divider,
    [Tag.name]: Tag,
    [Timeline.name]: Timeline,
    [TimelineItem.name]: TimelineItem,
    [Card.name]: Card,
    AuditSignature,
  },
  data() {
    return {
      search: "",
      resultsCount: 10,
    };
  },
  watch: {
    async activeTab(newTab, oldTab) {
      if (newTab == "AuditLog") {
        
      }
       
    },
     "$route.params.id": async function () {
           await this.loadAuditLogData(1, true);

    },
  },
async mounted() {
     // Initial load should clear to avoid duplicates from previous visits
     await this.loadAuditLogData(1, true);
     // Fetch user data for export filename
     if (this.$route.params.id) {
       await this.getUser(this.$route.params.id);
     }
  },
  filters: {
    formatDateTime(value) {
      if (!value) return "";
      const date = new Date(value);
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
    },
  },
  computed: {
    ...mapGetters({
      auditLogLoadingText: "userAuditlogs/auditLogLoadingText",
      auditLog: "userAuditlogs/getUserAuditLog",
      totalAuditLogCount: "userAuditlogs/getTotalUserAuditLogCount",
      activeTab: "tab/activeTab",
      user: "users/user",
    }),
    // Group audit log entries by logDate to combine records from the same action
    groupedAuditLog() {
      if (!this.auditLog || !this.auditLog.length) return [];
      
      // Filter out UpdateDate and signature date field entries (case-insensitive)
      const filteredLog = this.auditLog.filter(item => {
        const fieldName = (item.fieldName || '').trim().toLowerCase();
        // Exclude UpdateDate fields
        if (fieldName === 'updatedate' || fieldName === 'updateddate') return false;
        // Exclude signature date fields (e.g., "Acceptor Date Signed", "Requestor Date Signed", etc.)
        if ((fieldName.includes('signature') && fieldName.includes('date')) ||
            (fieldName.includes('date') && fieldName.includes('signed'))) return false;
        return true;
      });
      
      const groups = {};
      filteredLog.forEach(item => {
        const key = item.logDate;
        if (!groups[key]) {
          groups[key] = {
            logDate: item.logDate,
            items: []
          };
        }
        groups[key].items.push(item);
      });
      
      // Return as array, sorted by logDate descending, excluding empty groups
      return Object.values(groups)
        .filter(group => group.items.length > 0)
        .sort((a, b) => new Date(b.logDate) - new Date(a.logDate));
    },
    userIdFromRoute() {
      return this.$route.params.id;
    },
    isUserIdAvailable() {
      return !!this.$route.params.id;
    },
  },
  methods: {
    ...mapActions({
      fetchAuditLog: "userAuditlogs/fetchAuditLog",
      fetchAuditLogPagination: "userAuditlogs/fetchAuditLogPagination",
      getUser: "users/getUser",
    }),
    // Check if a field is a signature image field (not date/time/file fields that contain "signature")
    isSignatureField(fieldName) {
      if (!fieldName) return false;
      const lower = fieldName.toLowerCase();
      // Exclude non-image fields that contain "signature" (e.g., file names like "mysignature.png")
      if (lower.includes('date') || lower.includes('time') || lower.includes('reason')) return false;
      if (lower.includes('deleted file') || lower.includes('added new file') || lower.startsWith('file')) return false;
      return lower.includes('signature');
    },
    // Check if a value is actual signature image data (base64 encoded or data URI),
    // not a date string, "N/A", or other non-image text.
    isSignatureValue(value) {
      if (!value || value === 'N/A' || value === 'null') return false;
      if (value === '[SIGNATURE_PLACEHOLDER]') return true;
      // Date values from the backend are formatted as MM/dd/yyyy or MM/dd/yyyy HH:mm:ss.
      // If the value matches a date pattern, it is not signature image data.
      if (Util.isAuditDateValue(value)) return false;
      // Any non-null, non-date value in a signature field is signature image data
      return true;
    },
    async loadAuditLogData(pageNumber, isclear = false) {
      if (this.isUserIdAvailable) {
        // await  this.fetchAuditLog(this.orderId);

        // same way to pass apiInfor to the search, there is no export flag
        let apiInfo = {
          userId:  this.$route.params.id,
          pageNumber: pageNumber ? pageNumber : 1,
          resultsPerPage: this.resultsCount,
          searchText: this.search,
          isClear: isclear
        };
        await this.fetchAuditLogPagination(apiInfo);
      }
    },
    async loadMoreAuditLogs() {
      this.$loaderApp.addRequest();
      let pageNo = this.auditLog.length / this.resultsCount + 1;
      await this.loadAuditLogData(pageNo, false);
      this.$loaderApp.completeRequest();
    },
    async searchInput() {
      this.$loaderApp.addRequest();
      let pageNo = this.auditLog.length / this.resultsCount
      this.pageNumber = pageNo < 1 ? 1 : pageNo

      await this.loadAuditLogData(this.pageNumber, true)
      this.$loaderApp.completeRequest();

    },

    exportPDF() {
      this.$loaderApp.addRequest();
      // Build URL - only include search parameter if it has a value
      const searchParam = this.search ? `/${encodeURIComponent(this.search)}` : '';
      axios({
        url: `/api/userauditlogs/pdf/${this.$route.params.id}${searchParam}`,
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        // Build filename from user's name in store
        let fileName = "Audit_Log_Summary";
        if (this.user && (this.user.lastName || this.user.firstName)) {
          const nameParts = [];
          if (this.user.lastName) nameParts.push(this.user.lastName.trim().replace(/\s+/g, "_"));
          if (this.user.firstName) nameParts.push(this.user.firstName.trim().replace(/\s+/g, "_"));
          fileName = `Audit_Log_Summary_${nameParts.join("_")}`;
        }
        Util.fileDownload(response.data, `${fileName}.pdf`);
        this.$loaderApp.completeRequest();
      }).catch((error) => {
        this.$loaderApp.completeRequest();
        // Extract message from various error formats
        let message = "An error occurred while exporting the PDF.";
        
        if (!error.response) {
          // No response -- network error, blocked, or timeout
          message = error.message || "Unable to reach the server. Please check your connection.";
        } else if (error.response.status === 500) {
          message = "Server error occurred while generating the PDF.";
        } else if (error.response.status === 404) {
          message = "Audit log not found.";
        }
        
        this.$toast.error(String(message));
      });
    },
    
    // Helper methods for parsing file audit field names
    // Format: "File - SIGNATURE AUTHORITY [ScreenStuck2025-05-28 130933.png] - Document Date"
    getShortFieldName(fieldName) {
      // Extract just the last part after the last " - " (e.g., "Document Date")
      if (!fieldName) return '';
      const lastDashIndex = fieldName.lastIndexOf(' - ');
      if (lastDashIndex > -1) {
        return fieldName.substring(lastDashIndex + 3);
      }
      return fieldName;
    },
    
    getFileType(fieldName) {
      // Extract file type between "File - " and "[" and convert to title case
      if (!fieldName) return 'N/A';
      const match = fieldName.match(/^File\s*-\s*(.+?)\s*\[/);
      if (match) {
        // Convert to title case (e.g., "SIGNATURE AUTHORITY" -> "Signature Authority")
        return Util.toTitleCase(match[1].trim());
      }
      return 'N/A';
    },
    
    getFileName(fieldName) {
      // Extract file name between "[" and "]"
      if (!fieldName) return 'N/A';
      const match = fieldName.match(/\[(.+?)\]/);
      return match ? match[1].trim() : 'N/A';
    },
    
    formatFullName(user) {
      // Format: LastName, FirstName MI (if middle initial exists)
      if (!user) return '';
      const parts = [];
      if (user.lastName) parts.push(user.lastName);
      if (user.firstName) {
        const firstName = user.firstName;
        const middleInitial = user.middleInitial ? ` ${user.middleInitial}` : '';
        parts.push(`${firstName}${middleInitial}`);
      }
      return parts.length > 0 ? parts.join(', ') : user.email || '';
    },
    
    /**
     * Format value based on its data type - delegates to Util.formatValue.
     * Document Date fields are date-only — time is stripped for both new and existing audit entries.
     */
    formatValue(value, valueDataType, fieldName) {
      if (fieldName && fieldName.includes('Document Date') && value && Util.isAuditDateValue(String(value))) {
        return dayjs(String(value), ['M/D/YYYY', 'M/D/YYYY HH:mm:ss'], true).format('M/D/YYYY');
      }
      return Util.formatValue(value, valueDataType);
    },
  },
};
</script>

<style>
.row .search-box {
  margin-bottom: 5em;
}

.divider-green {
  background-color: #10b45a;
}

.el-table--border {
  border: 1px solid rgba(34, 42, 66, 0.2);
}

ul.el-timeline {
  padding-inline-start: 0;
}
</style>